module.exports = __webpack_public_path__ + "static/media/vktr.e2f92c9d.svg";